// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('product.businessareas', {
        url: '/businessareas?searchTerm',
        views: {
            'productList': {
            templateUrl: 'main/product/businessareas/businessareas.tpl.html',
            controller: 'BusinessAreasController as vm'
        }},
        resolve: {
            businessareas: businessareasResolver,
            searchTerm: searchTermesolver
        }
    });
}

// @ngInject
function businessareasResolver(BusinessAreasApiService, $stateParams) {
    return BusinessAreasApiService.getBusinessAreas({ page: 0, searchTerm:$stateParams.searchTerm, pageSize: null});
}
// @ngInject
function searchTermesolver($stateParams) {
    return $stateParams.searchTerm;
}
// @ngInject
function BusinessAreasController($rootScope, $state, $scope, businessareas, BusinessAreasApiService, loadSpinnerService, searchTerm) {
    var vm = this;

    vm.currentUser = $rootScope.currentUser;

    vm.businessareas = businessareas;
    vm.selectedBusinessAreaId = 0;
    vm.searchTerm = (searchTerm) ? searchTerm : '';
    vm.currentPage = 1;

    vm.searchTermChange = searchTermChange;

    activate();

    function activate() {
        $scope.$watch(function() { return $state.params.businessAreaId; }, function(newValue, oldValue) {
            vm.selectedBusinessAreaId = parseInt($state.params.businessAreaId,10);
        });
        $rootScope.$on('BusinessArea.Inserted', function(event, response) {
        });
        $rootScope.$on('BusinessArea.Updated', function(event, response) {
        });
        $rootScope.$on('BusinessArea.Deleted', function(event, response) {
        });
        $rootScope.$on('BusinessArea.Changed', function(event, response) {
            loadBusinessAreas();
        });
    }

    function loadBusinessAreas() {
        loadSpinnerService.start('mainSpinner');
        var request = { page: (vm.currentPage - 1), searchTerm:vm.searchTerm, pageSize:vm.itemsPerPage};
        BusinessAreasApiService.getBusinessAreas(request).then(function(response) {
            vm.businessareas = response;
        }).finally(function () {
            loadSpinnerService.stop('mainSpinner',{force: true});
        });
    }

    function searchTermChange() {
        vm.currentPage = 1;
        loadBusinessAreas();
    }

}

angular
    .module('product.businessareas', ['businessareas.api','businessareas.businessarea'])
    .config(stateConfig)
    .controller('BusinessAreasController', BusinessAreasController);
